import { render, staticRenderFns } from "./temporary-orders.vue?vue&type=template&id=234f99d8&scoped=true&"
import script from "./temporary-orders.vue?vue&type=script&lang=js&"
export * from "./temporary-orders.vue?vue&type=script&lang=js&"
import style0 from "./temporary-orders.vue?vue&type=style&index=0&id=234f99d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234f99d8",
  null
  
)

export default component.exports